module.exports = __webpack_public_path__ + "static/media/cs.a9c425e7.jpg";